import { createResource } from 'react-resource-router';

import { AccessKeysResponse } from 'src/components/settings/access-keys';
import { DEFAULT_ROWS_PER_PAGE } from 'src/constants/settings';
import urls from 'src/sections/repository/urls';
import { httpRequest } from 'src/utils/http-request';

type FetchSshKeysOptions = { page?: number; pagelen?: number; sort?: string };

export const fetchSshKeys =
  (repositoryOwner: string, repositorySlug: string) =>
  (options?: FetchSshKeysOptions) =>
    httpRequest<AccessKeysResponse>().get(
      urls.api.v20.deployKeys(repositoryOwner, repositorySlug, {
        ...options,
      })
    );

export const loadRepositorySettingsAccessKeysResource = createResource({
  type: 'repoAdminAccessKeys',
  getKey: ({ match }) => {
    const { repositoryOwner, repositorySlug } = match.params;
    return urls.ui.adminPage(repositoryOwner!, repositorySlug!, 'access-keys');
  },
  maxAge: 60000, // cache for 1 minute so navigating between pages is fast
  getData: ({ match }) => {
    const { repositoryOwner, repositorySlug } = match.params;
    if (!repositoryOwner || !repositorySlug) {
      throw new Error(
        'Could not fetch, repositorySlug/repositoryOwner URL param was not available'
      );
    }
    const { pagelen = DEFAULT_ROWS_PER_PAGE, page = 1, sort } = match.query;
    return fetchSshKeys(
      repositoryOwner,
      repositorySlug
    )({
      pagelen: ~~pagelen,
      page: ~~page,
      sort,
    });
  },
});
